import * as React from "react";
import { forwardRef } from "react";
const SvgAppraisalDashboardIcon = (props, ref) => <svg width={16} height={16} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}><path d="M8.5 6.5V2H14v4.5H8.5zM2 8.5V2h5.5v6.5H2zM8.5 14V7.5H14V14H8.5zM2 14V9.5h5.5V14H2zm1-6.5h3.5V3H3v4.5zM9.5 13H13V8.5H9.5V13zm0-7.5H13V3H9.5v2.5zM3 13h3.5v-2.5H3V13z" fill="#32325D" fillRule="nonzero" /></svg>;
const ForwardRef = forwardRef(SvgAppraisalDashboardIcon);
export { ForwardRef as ReactComponent };
import __svgUrl from "/home/jenkins/agent/workspace/k_Connect_service_dev_qa-release/src/icons/appraisal-dashboard-icon.svg?url";
export default __svgUrl;
